import {getAssetUrl} from '@Utils/s3.util';
import type {LayersVisualConfig} from '@Modals/ai-action-loading-modal/ai-action-loading-modal.types';
import type {LayerOffset, LayersAnimationConfig} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';
import {getLayerPoses, getLayersAnimationTiming, LayerRole, LayersLoopMode} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';

const MDE_LAYERS_TRANSITION_S = 2;
const MDE_COMPOSED_OFFSET: LayerOffset = {x: '0%', y: '11%'};

export const MDE_LOADER_ANIMATION: LayersAnimationConfig = {
  layers: [
    {role: LayerRole.BACKGROUND, imageUrl: getAssetUrl('mde-layers-loader-bg.webp'), poses: getLayerPoses({x: '23.2%', y: '-1.7%'}, MDE_COMPOSED_OFFSET)},
    {role: LayerRole.PHOTO, imageUrl: getAssetUrl('mde-layers-loader-photo.webp'), poses: getLayerPoses({x: '3.9%', y: '11%'}, MDE_COMPOSED_OFFSET)},
    {role: LayerRole.TEXT, imageUrl: getAssetUrl('mde-layers-loader-text.webp'), poses: getLayerPoses({x: '-16.7%', y: '22.5%'}, MDE_COMPOSED_OFFSET)},
  ],
  timing: getLayersAnimationTiming(MDE_LAYERS_TRANSITION_S),
  loopMode: LayersLoopMode.TIMED,
};

export const getMdeLoadingTitle = (): string => {
  return window.i18next.t('pmwjs_mde_extracting_design_layers');
};

export const getMdeLayersVisualConfig = (): LayersVisualConfig => {
  return {
    loadingTitle: getMdeLoadingTitle(),
    readyTitle: window.i18next.t('pmwjs_mte_edit_design'),
    animation: MDE_LOADER_ANIMATION,
  };
};
